// AUTO-GENERATED by scripts/build-reviews.mts. Do not edit by hand.
// Re-run via `npx nx run russrodgersbassguitar:generate-reviews`.
import type { ReviewsAggregate } from './reviews-types';

export const GOOGLE_REVIEWS_AGGREGATE: Readonly<ReviewsAggregate> = {
  count: 28,
  averageRating: 5,
};
